import React, { useState } from 'react';
import Select from 'react-select';
import api from '@/auth/api';
import { alertError, alertSuccess } from '@/components/Alert';

function AreaModal({rowId}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [areaOptions, setAreaOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false); // Loading state

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleKeyDown = async (e) => {
    if (e.key === 'Enter' && inputValue.length >= 3) {
      e.preventDefault();
      setLoading(true); // Start loading

      try {
        const response = await api.get(
          `/location/panel/Location?SearchKey=Area&SearchVal=${inputValue}`
        );
        const options = response.data?.result?.Area?.map((area) => ({
          value: area.id,
          label: area.title,
        })) || [];

        setAreaOptions(options);
      } catch (error) {
        console.error('Error fetching areas:', error);
        setAreaOptions([]);
      } finally {
        setLoading(false); // Stop loading
      }
    }
  };

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const handleSubmit = async () => {
    if (!selectedOption) {
      alert('Please select an area');
      return;
    }

    try {
      await api.patch('/location/panel/Map', {
        id:rowId,
        Area: selectedOption.value,
      });

      alertSuccess('Area updated successfully!');
    } catch (error) {
      alertError('Failed to update area.');
    }
  };

  return (
    <div className="p-4 overflow-hidden min-h-[200px]">
     <Select
  options={areaOptions}
  onInputChange={handleInputChange}
  onKeyDown={handleKeyDown}
  onChange={handleChange}
  value={selectedOption}
  placeholder="Type area name and press Enter..."
  className="mb-4"
  isClearable
  isDisabled={loading}
  isLoading={loading}
  menuPlacement="bottom" // helps with dropdown placement inside modals
  styles={{
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // make sure it's above the modal content
      maxHeight: 200, // limits dropdown height
      overflowY: 'hidden',
    }),
  }}
/>


      {loading && (
        <p className="text-sm text-gray-500 mb-2">Loading areas...</p>
      )}

      <button
        onClick={handleSubmit}
        className="bg-[var(--mainCol)] text-white px-4 py-2 rounded hover:bg-[mainColHover]"
        disabled={loading}
      >
        Submit
      </button>
    </div>
  );
}

export default AreaModal;
